// src/lib/sync/onlineStatus.js
// ─────────────────────────────────────────────────────────────
//  Tiny observable wrapper around navigator.onLine.
//  Consumers can subscribe to online/offline transitions.
// ─────────────────────────────────────────────────────────────

const listeners = new Set();

function notify(online) {
  listeners.forEach((fn) => fn(online));
}

window.addEventListener('online',  () => notify(true));
window.addEventListener('offline', () => notify(false));

/**
 * Returns true if the browser currently believes it is online.
 */
export function isOnline() {
  return navigator.onLine;
}

/**
 * Subscribe to online/offline changes.
 * @param {(online: boolean) => void} fn
 * @returns {() => void}  unsubscribe
 */
export function onOnlineChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}